// extracted by mini-css-extract-plugin
export var typeLarge = "Footer-module--type-large--Wic3o";
export var typeMedium = "Footer-module--type-medium--Jy5jr";
export var typeBody = "Footer-module--type-body--6NAco";
export var homeIcon = "Footer-module--home-icon--aDdS6";
export var footer = "Footer-module--footer--j7LCq";
export var footerInner = "Footer-module--footer-inner--jrGRH";